var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C6.62 2.25 2.25 6.62 2.25 12C2.25 17.38 6.62 21.75 12 21.75C17.38 21.75 21.75 17.38 21.75 12C21.75 6.62 17.38 2.25 12 2.25ZM12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 7.45 7.45 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 16.55 16.55 20.25 12 20.25Z",
    fill: "var(--color-color11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5299 8.46994C15.2399 8.17994 14.7599 8.17994 14.4699 8.46994L11.9999 10.9399L9.52994 8.46994C9.23994 8.17994 8.75994 8.17994 8.46994 8.46994C8.17994 8.75994 8.17994 9.23994 8.46994 9.52994L10.9399 11.9999L8.46994 14.4699C8.17994 14.7599 8.17994 15.2399 8.46994 15.5299C8.61994 15.6799 8.80994 15.7499 8.99994 15.7499C9.18994 15.7499 9.37994 15.6799 9.52994 15.5299L11.9999 13.0599L14.4699 15.5299C14.6199 15.6799 14.8099 15.7499 14.9999 15.7499C15.1899 15.7499 15.3799 15.6799 15.5299 15.5299C15.8199 15.2399 15.8199 14.7599 15.5299 14.4699L13.0599 11.9999L15.5299 9.52994C15.8199 9.23994 15.8199 8.75994 15.5299 8.46994Z",
    fill: "var(--color-color11)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconRed);
export default __webpack_public_path__ + "static/media/cross_icon-red.ece5f6482826c65b50a9cd1f15797401.svg";
export { ForwardRef as ReactComponent };